import * as Yup from "yup";
import i18n from "../i18n";

export const LocationsSchema = Yup.object({
  locationEn: Yup.string().required(
    i18n.language === "en"
      ? "Location (English) is required"
      : "الموقع (بالإنجليزية) مطلوب"
  ),
  locationAr: Yup.string().required(
    i18n.language === "en"
      ? "Location (Arabic) is required"
      : "الموقع (بالعربية) مطلوب"
  ),
  description: Yup.string().nullable(),
});
